export enum WITH_SITE_TITLE {
  APPEND = 'append',
  PREPEND = 'prepend',
  OFF = 'off',
}
